module.exports = __webpack_public_path__ + "static/media/F-N.746269b8.webp";